import React, { useState } from 'react';
import './HtmlResponseViewer.css';

export const HtmlResponseViewer = ({ htmlContent }) => {
    return (
        <div className="html-response-viewer">
            <h2>HTML Response</h2>
            <div className="html-rendered section no-shadow">
                <h2>Rendered HTML :</h2>
                <div dangerouslySetInnerHTML={{ __html: htmlContent }} />
            </div>
            <div className="html-raw section no-shadow">
                <h2>Raw HTML :</h2>
                <pre>{htmlContent}</pre>
            </div>
        </div>
    );
};
